const state = {
  schemes: [],
  tncHeaderFooterOptions: [],
  generalMasterData: {
    revisionID: "",
    planNo: "",
    incentiveAudience: [],
    division: [],
    productType: [],
    productCategory: [],
    payto: [],
    legacyApp: [],
    budgetCategory: [],
    bufferTypeList: [],
    executionType: [],
    branchType: [],
    branchNames:[],
    purpose:[]
  },
  createSchemeForm: {
    planNo: undefined,
    general: {},
    program: {},
    programSelectedRow: {},
    planRow: {},
    createSchemeFlag: "",
  },
  groups: [],
  createPartnerGroupData: {
    groupId: null,
    groupName: null,
    divisionCode: [],
    channelCode: [],
    groupType: [],
    groupException: [],
    geoElement: [],
    geoValue: [],
    partnerAttribute: [],
    partnerType: [],
  },
  createProductGroupData: {
    groupId: null,
    groupName: null,
    divisionCode: [],
    groupType: [],
    partnerAttribute: [],
    partnerType: [],
  },
  partnerGroups: [],
  productGroups: [],
  singleGroupData: {},
  groupTypeDetails: {},
  loader: {
    viewGroupLoader: false,
  },
  productLevelData: [],
  schemeProgramMasterData: {
    segment: [],
    budgetCategory: [],
    budgetSubCategory: [],
    payoutOnList: [],
    natureList: [],
    relationMastersList: [],
    quarterList: [],
    kpiMasters: [],
    hoRemarks: [],
    branchRemarks: [],
    settlementTypeList: [],
  },
  eligibilityMasterData: {
    nature: [],
    slabType: [],
    applicableOn: [],
    calculatedOn: [],
    stockType: [],
    productLink: [],
    level: [],
    cappingOn: [],
    skuCodes: [],
    noPayoutProductGroup: [],
    eligibiltyTypes: [],
    eligibilityOn: [],
    payoutTypes: [],
  },
  targetMasterData: {
    mode: [],
    stockType: [],
    targetSource: [],
    applicableOn: [],
    calculateOn: [],
    method: [],
    productGroupList: [],
  },
  payoutMasterData: {
    level: [],
    stockType: [],
    calculateOn: [],
    productLink: [],
    supportType: [],
    category: [],
    targetSource: [],
  },
  vallidationLinkData: [],
  targetLinkData: [],
  selectedPatnerDetail: [],
  bugetSubCatItem: [],
  generalSectionData: {},
  partnerGeo: {
    geoElement: [],
    GeoValue: [],
  },
  eligibilityRangeStartDate: "",
  slabMinValue: 0,
  demoDeductionStartDateValue: 0,
  bizSlabMinValue: 0,
  schemeProgramData: {},
  viewTarget: [],
  targetException: [],
  schemeExceptionSelectedPlans: {
    selectedPlanNos: [],
    canCheckschemePlanList: "",
  },
  selectedPlanListRows: [],
  schemeExceptionMasterDropDown: {},
  partnerTypeFromLists: [],
  partnerCodeListsSellerExclusion: [],
  partnerTypeToLists: [],
  demoDropDownOptionsData: {
    calculatedOn: [],
    fromDate: "",
    payoutLevel: [],
    supportType: [],
    toDate: "",
  },
  storeConditionEligibityArr: [],
  isAddModifyAddProgramValue: false,
  purposeSelecItem: [],
  schemeFamilySelecItem: "",
  storeAddProgramForReportPayoutData: {},
  storePartnerGroupIdItemForDemoDeduction: [],
  viewAllMergePlanData: [],
  payoutOnSelec: "",
  nerpCampaignMaster: [],
  holdSignleSelectSchedulePayoutCommValue: {},
};
export default state;
